import React from 'react';

export default function SparkleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 1.33334L9.7333 6.26667L14.6667 8L9.7333 9.7333L8 14.6667L6.26667 9.7333L1.33334 8L6.26667 6.26667L8 1.33334Z"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M13.3333 1.33334V4" stroke="#43A047" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14.6667 2.66666H12" stroke="#43A047" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
